import { FetchHelperOptions, IFetchHelper } from './IFetchHelper';
import opentelemetry, { SpanKind, Tracer } from '@opentelemetry/api';

const TRACER_NAME = 'FetchHelper';

const defaultTracer = opentelemetry.trace.getTracer(TRACER_NAME);
export class FetchHelper implements IFetchHelper {
  constructor(private readonly _tracer?: Tracer) {}

  async fetch(
    url: string,
    options: FetchHelperOptions = {},
  ): Promise<Response> {
    const { throwOnHttpError = true, ...init } = options;
    const method = init.method || 'GET';
    const tracer = this._tracer || defaultTracer;
    const span = tracer.startSpan(`FETCH ${method} ${url}`, {
      kind: SpanKind.CLIENT,
    });
    try {
      const response = await fetch(url, init);

      if (!response.ok && throwOnHttpError) {
        // Query string stripped: some callers pass tokens in it (e.g. Spreedly ?token=)
        throw Object.assign(
          new Error(`HTTP ${response.status} for ${url.split('?')[0]}`),
          {
            code: response.status,
            body: await response.text().catch(() => ''),
          },
        );
      }

      return response;
    } catch (err: unknown) {
      const error = err as Error & { code?: number };
      span.recordException({
        message: error.message,
        name: typeof error.name === 'string' ? error.name : 'Error',
        stack: error.stack,
        code: error?.code,
      });
      throw error;
    } finally {
      span.end();
    }
  }
}
